import { firebaseApp } from './Firebase'
import 'firebase/compat/remote-config'

export enum ConfigValue {
  appConfigHost = 'app_config_host',
  deepLinkDomain = 'deep_link_domain',
  deepLinkItem = 'deep_link_item',
  shareAndroidPackage = 'share_android_package',
  shareIOSId = 'share_ios_id',
  shareIOSPackage = 'share_ios_package',
  shopifyApiBaseUrl = 'shopify_api_base_url',
  shopifyApiToken = 'shopify_api_token',
  defaultDynamicLink = 'default_dynamic_link'
}

export const utmAppname = 'quotes' // Google Campaign source
export const dynamicLinksService = 'https://dynamic-links.live.sprueche-app.de'
export const remoteConfig = firebaseApp.remoteConfig()
remoteConfig.settings.minimumFetchIntervalMillis = 30000 // 3600000

remoteConfig.defaultConfig = {
  app_config_host: 'https://live.sprueche-app.de',
  deep_link_domain: 'https://vonherzen.sprueche-app.de',

  // The following values don't exist in firebase anymore
  deep_link_item: 'https://sprueche-app.de/detail/{itemId}',
  share_android_package: 'com.megalol.quotes',
  share_ios_id: 'id1059663972',
  share_ios_package: 'com.megalol.quotes',
  shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
  shopify_api_token: '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',
  default_dynamic_link: 'https://vonherzen.sprueche-app.de'
}

remoteConfig.fetchAndActivate()
